import React from "react";
import { Box } from "@mui/material";
import useMobileLayout from "../../../hooks/useMobileLayout";
import ReportDetailsCard from "./ReportDetailsCard";
import ReportDownloadActions from "./ReportDownloadActions";
import { SectionTitle, TextCard } from "./DataDisplay";
import { EcgGraphSection } from "./EcgGraphCards";
import { useContext } from "react";
import { AuthContext } from "../../../context/AuthContextProvider";

import {
  CollectionDetailsCard,
  Interpretation,
  PatientSummaryCard,
  PatientVitalsCard,
  SendForInterpretationAccess,
  SymptomsCard,
} from "./ReportSections";
import { canViewAIgeneratedReports } from "./reportUtils";

const FullReport = ({
  setCreateModal,
  data,
  ecgGraph,
  isLoadingGraph,
  isLoading,
}) => {
  const isMobile = useMobileLayout();
  const { open, user } = useContext(AuthContext);
  // Migrated businesses don't get to send reports for interpretation -
  // userType stays plain "b2b", migration is a separate flag.
  const isMigratedUser = user?.userType === "b2b" && user?.migration === true;
  const status = data?.interpretation_request_status;
  const showFooter =
    status === "completed" ||
    (status !== "completed" && canViewAIgeneratedReports());

  return (
    <Box sx={{ pb: "80px" }}>
      <br />
      <PatientSummaryCard type="full" data={data} loading={isLoading} />

      <br />

      <Interpretation type="full" data={data} />
      <ReportDetailsCard type="interpretation" data={data} />

      <br />
      <PatientVitalsCard data={data} loading={isLoading} />

      <br />
      <CollectionDetailsCard data={data} loading={isLoading} />

      <SymptomsCard data={data} />

      <br />
      <TextCard
        sx={{ mt: 2 }}
        title="Medical History Notes"
        variant="outlined"
        cardSx={{ px: 3, py: 2 }}
        text={
          data?.medical_history_notes || "No medical history notes provided."
        }
      />

      <br />
      <SectionTitle>ECG Graph</SectionTitle>
      <EcgGraphSection
        data={data}
        ecgGraph={ecgGraph}
        isLoadingGraph={isLoadingGraph}
      />

      <ReportDetailsCard type="parameters" data={data} loading={isLoading} />

      {showFooter && (
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            p: "15px",
            pl: isMobile ? "15px" : open ? "285px" : "105px", // sidebar width + normal content padding           
            backgroundColor: "var(--app-surface)",
            borderTop: "1px solid var(--app-border)",
            textAlign: "left",
            zIndex: 1000,
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "12px",
            transition: "padding-left 300ms ease",
          }}
        >
          {status == null && !isMigratedUser && (
            <SendForInterpretationAccess>
              <Box sx={{ width: { xs: "100%", sm: "auto" } }}>
                <button
                  className="btn btn-added-primary"
                  onClick={() => setCreateModal(true)}
                  style={{
                    width: "100%",
                    minWidth: "190px",
                    height: "48px",
                    borderRadius: "9px",
                    padding: "14px 20px",
                    backgroundColor: "#4F46E5",
                    color: "#fff",
                    border: "none",
                    fontFamily: "Figtree",
                    fontWeight: 600,
                    fontSize: "15px",
                    textTransform: "none",
                    cursor: "pointer",
                  }}
                >
                  Send for Interpretation
                </button>
              </Box>
            </SendForInterpretationAccess>
          )}
          <ReportDownloadActions
            data={data}
            ecgGraph={ecgGraph}
            isLoadingGraph={isLoadingGraph}
            mode="footer"
          />
        </Box>
      )}
    </Box>
  );
};

export default FullReport;
